import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import DashboardSidebar from "../../components/DashboardSidebar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OrdersWrapper from "./OrdersWrapper";
import "./Orders.css";


const Orders: React.FC = () => {

  const [commissionData, setCommissionData] = useState<any | undefined>(undefined);

  const { store_id } = useParams<{ store_id?: string }>();

  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  const location = useLocation();
  const storeName = location.state?.storeName?.split(' ').map((w: string) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ') ?? "";

  return (
    <div className="orders-page-wrapper">
      {currentRole !== 1 && (
        <DashboardSidebar commissionData={commissionData} />
      )}
      <div className="orders-content">
        <div className="orders-wrapper">

          <div className="orders-toolbar">
            {(currentRole==1)?(
              <span onClick={() => window.history.back()} className="collections-back-btn">
                {storeName && (
                  <><ArrowBackIcon />
                 <span className="collections-back-label">{storeName}</span></>)}
              </span>
            ) : <span />}
          </div>

          <OrdersWrapper 
            storeId={store_id}
            onCommissionData={currentRole !== 1 ? setCommissionData : undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default Orders;